import { TaskTiming, TaskTimingLabels } from '@navio/nsdk';

/** When a task is done, in the words of the person doing it; the backend's labels name the model, not the moment. */
export const TASK_TIMING_LABELS: Record<TaskTiming, string> = {
  ...TaskTimingLabels,
  [TaskTiming.UNSPECIFIED]: 'Custom',
  [TaskTiming.BEFORE_ROUTE]: 'Before starting on route',
  [TaskTiming.AFTER_ROUTE]: 'After finishing route',
  [TaskTiming.BEFORE_BOOKING]: 'When arriving at customer location',
  [TaskTiming.AFTER_BOOKING]: 'When leaving customer location',
  [TaskTiming.BEFORE_BOOKING_ITEM]: 'Before starting service on car',
  [TaskTiming.DURING_BOOKING_ITEM]: 'While servicing car',
  [TaskTiming.AFTER_BOOKING_ITEM]: 'After ending service on car'
};
